"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useTreeContextMenu = function useTreeContextMenu() {
  var _useState = (0, _react.useState)("0px"),
      _useState2 = _slicedToArray(_useState, 2),
      xPos = _useState2[0],
      setXPos = _useState2[1];

  var _useState3 = (0, _react.useState)("0px"),
      _useState4 = _slicedToArray(_useState3, 2),
      yPos = _useState4[0],
      setYPos = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showMenu = _useState6[0],
      setShowMenu = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      rightClickedNode = _useState8[0],
      setRightClickedNode = _useState8[1];
  /**
   * Method to handle the right click in the tree node view
   * This method will store the needes states to show the
   * context menu
   */


  var onRightClickNode = (0, _react.useCallback)(function (e) {
    var node = e.node;
    var event = e.event;
    setXPos("".concat(event.clientX, "px"));
    setYPos("".concat(event.clientY, "px")); // setXPos(`${event.pageX}px`);
    // setYPos(`${event.pageY}px`);

    setShowMenu(true);
    setRightClickedNode(node);
  }, [setXPos, setYPos]);
  /**
   * Handle to set the menu context invisible once 
   * the user clicks in the context menu or outside it
   */

  var handleClick = (0, _react.useCallback)(function () {
    showMenu && setShowMenu(false);
  }, [showMenu]);
  /**
   * Effect to register/unregister the click mouse
   * event responsible to make invisible to context
   * menu
   */

  (0, _react.useEffect)(function () {
    document.addEventListener("click", handleClick);
    return function () {
      document.removeEventListener("click", handleClick);
    };
  }, [handleClick]);
  return {
    xPos: xPos,
    yPos: yPos,
    showMenu: showMenu,
    rightClickedNode: rightClickedNode,
    onRightClickNode: onRightClickNode
  };
};

var _default = useTreeContextMenu;
exports.default = _default;